import { Button } from "@heroui/react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const cn = (...inputs) => twMerge(clsx(inputs));

/**
 * @param {{
 *   title?: any;
 *   icon?: any;
 *   onClick?: any;
 *   textColor?: string;
 *   className?: string;
 *   disabled?: boolean;
 *   size?: string;
 *   isLoading?: boolean;
 *   endContent?: any;
 * }} [props]
 */
const SecondaryButton = ({
  title = "",
  icon,
  onClick,
  textColor = "light",
  className = "",
  disabled = false,
  size = "sm",
  isLoading = false,
  endContent,
} = {}) => {
  const hasCustomBg = className.includes("bg-");
  const hasCustomBorder = className.includes("border-");

  return (
    <Button
      className={cn(
        "px-[14px] py-[8px] gap-[6px] h-fit flex items-center justify-center text-xs font-semibold shadow-xs rounded-lg transition-colors",
        !hasCustomBg && "bg-white dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800/80 shadow-[ 0px_1px_2px_0px_rgba(255,255,255,0.25)_inset]",
        !hasCustomBorder && "border border-gray-300 dark:border-gray-800",
        textColor === "light" ? "text-gray-700 dark:text-gray-200" : "text-gray-800 dark:text-gray-100",
        className,
      )}
      onPress={onClick}
      size={size}
      isDisabled={disabled}
      isLoading={isLoading}
    >
      {icon && <span>{icon}</span>} {title}{" "}
      {endContent && <span>{endContent}</span>}
    </Button>
  );
};

export default SecondaryButton;
